import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import ArrowRight from '../../../../icons/arrow-right.svg';

const AppTile = (props) => {
  const { slug, image, developer, name, description, showContact } = props;

  return (
    <Wrapper>
      <Box to={`/partners/apps/${slug}`}>
        <Content>
          <StyledImageWrapper>
            <StyledImage src={image} alt={name} />
          </StyledImageWrapper>

          <Title>{name}</Title>
          {developer && <Developer>By {developer}</Developer>}
          <Description>{description}</Description>
        </Content>
        {showContact && (
          <Actions>
            Contact <ArrowRight />
          </Actions>
        )}
      </Box>
    </Wrapper>
  );
};

const StyledImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

const Box = styled(Link)`
  border: 1px solid rgb(220, 223, 232);
  box-shadow: 1px 2px 8px rgba(7, 32, 128, 0.08);
  border-radius: 8px;
  background: white;
  padding: 25px;
  height: 100%;
  display: block;
  transform: translateY(0px);
  transition: all 0.3s linear;
  display: flex;
  flex-direction: column;
  &:hover,
  &:focus {
    transform: translateY(-5px);
    svg {
      transform: translateX(5px);
    }
  }
  .gatsby-image-wrapper {
    margin-bottom: 30px;
    display: block;
    min-height: 100px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  padding: 0 10px;
  margin-bottom: 20px;
  ${({ theme }) => `
    @media ${theme.mediumUp} {
        width: 50%;
    }
    @media ${theme.largeUp} {
        width: 33%;
    }
    @media ${theme.xLargeUp} {
        width: 25%;
    }
  `}
`;

const Content = styled.div`
  flex: auto;
`;

const Title = styled.h5`
  color: var(--blue-dark);
  font-size: var(--heading-size-xs);
  font-weight: var(--font-weight-bold);
  line-height: var(--heading-size-sm);

  margin-bottom: 5px;
`;

const Developer = styled.p`
  color: var(--gray-dark);

  margin-bottom: 15px;
`;

const Description = styled.p`
  font-size: 16px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  color: var(--blue-base);
  margin-top: 30px;
  svg {
    transition: all 0.3s linear;
    margin-left: 10px;
  }
`;

const StyledImage = styled.img`
  max-height: 100px;
  max-width: 220px;
  margin: auto;
`;

export default AppTile;
